var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22C1.45 22 0.979333 21.8043 0.588 21.413C0.196 21.021 0 20.55 0 20V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H10C10.55 0 11.021 0.195667 11.413 0.587C11.8043 0.979 12 1.45 12 2V20C12 20.55 11.8043 21.021 11.413 21.413C11.021 21.8043 10.55 22 10 22H2ZM2 20H10V2H2V20Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 6,
    height: 5,
    fill: "none",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H5",
    stroke: "white",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6V4H7V6",
    stroke: "white",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6V7H9",
    stroke: "white",
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 12H4.2V11.2H5V10.8H4.2V10H3.8V10.8H3V11.2H3.8V12Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.2H9V10.8H7V11.2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.5L7.5 17L5 18.5V15.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.2fe9142ccf5c8fe1eca44a254f65da72.svg";
export { ForwardRef as ReactComponent };